export const GiftCardSmall = () => (
  <svg
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="elements">
      <path
        id="Vector"
        d="M0.791016 7.27148C0.791016 4.44306 0.791016 3.02884 1.6697 2.15016C2.54837 1.27148 3.96259 1.27148 6.79102 1.27148H14.791C17.6194 1.27148 19.0337 1.27148 19.9123 2.15016C20.791 3.02884 20.791 4.44306 20.791 7.27148V11.2715C20.791 14.0999 20.791 15.5141 19.9123 16.3928C19.0337 17.2715 17.6194 17.2715 14.791 17.2715H6.79102C3.96259 17.2715 2.54837 17.2715 1.6697 16.3928C0.791016 15.5141 0.791016 14.0999 0.791016 11.2715V7.27148Z"
        stroke="#FBEA00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M4.79102 7.17578C4.79102 2.63136 10.791 7.26164 10.791 10.2715H7.29102C5.55422 10.2715 4.79102 8.74135 4.79102 7.17578Z"
        stroke="#FBEA00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M16.791 7.17577C16.791 2.63136 10.791 7.26164 10.791 10.2715H14.291C16.0278 10.2715 16.791 8.74135 16.791 7.17577Z"
        stroke="#FBEA00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M10.791 1.27148V17.2715"
        stroke="#FBEA00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M0.791016 10.2715H20.791"
        stroke="#FBEA00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M13.791 13.2715L10.791 10.2715L7.79102 13.2715"
        stroke="#FBEA00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
